import { render } from "./Drug.vue?vue&type=template&id=700a4b6b"
import script from "./Drug.vue?vue&type=script&lang=js"
export * from "./Drug.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__